/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail.depts', {
            parent: 'board.dinghy.event.detail',
            url: '/depts',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER', 'ROLE_FINANCE'],
                pageTitle: 'askApp.project.dept.title'
            },
            views: {
                'dinghyDetail@board.dinghy.event.detail': {
                    templateUrl: 'app/board/dinghy/event/detail/depts/depts.html',
                    controller: 'DinghyEventDeptsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    $translatePartialLoader.addPart('enumPaymentCategory');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.dinghy.event.detail.depts.edit-dept', {
            parent: 'board.dinghy.event.detail.depts',
            url: '/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.depts', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.depts.new-dept', {
            parent: 'board.dinghy.event.detail.depts',
            url: '/new/{userId}',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id: $stateParams.userId}).$promise;
                        }],
                        entityProject: null,
                        entityDinghyEvent: entity
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.depts', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.depts.new-dept-event', {
            parent: 'board.dinghy.event.detail.depts',
            url: '/new',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: entity
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.depts', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
